import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-survey-final-decision-selector',
  templateUrl: './survey-final-decision-selector.component.html',
  styleUrls: ['./survey-final-decision-selector.component.scss'],
  standalone: false,
})
export class SurveyFinalDecisionSelectorComponent {
  @Input() element: any;
  @Input() survey: any;
  @Input() statuses: Array<{ id: string; title: string; titleNoRev: string; icon: string; bgcolor: string }> = [];
  // Revise/Revise-and-split aprono una pipeline AI pensata per uno statement
  // testuale valutativo - non ha senso proporle per tipologie diverse da
  // CONSENSUS (es. multiple choice, griglie).
  @Input() typology: string;

  @Output() decisionChange = new EventEmitter<{ element: any; decision: string | null }>();

  /** Decisioni effettivamente proponibili per questa domanda. */
  get visibleStatuses() {
    if (this.typology === 'CONSENSUS') {
      return this.statuses;
    }
    return this.statuses.filter((s) => s.id !== 'revised' && s.id !== 'revised_split');
  }

  get selectedStatus() {
    if (!this.element?.final_decision) return null;
    return this.statuses.find((s) => s.id === this.element.final_decision) ?? null;
  }

  onSelectDecision(decision: string) {
    this.decisionChange.emit({ element: this.element, decision });
  }
}
